import vuetify from "@/main";
import ExpenseEdit from '@/modules/expenses/ExpenseEdit.vue';
import ExpenseLists from '@/modules/expenses/ExpenseLists.vue';
import QBOexpense from '@/modules/expenses/QBOexpense.vue';
import UnassignedTable from '@/modules/expenses/UnassignedTable.vue';
import ExpenseImport from '@/modules/expenses/ExpenseImport.vue';
import EquitracImport from '@/modules/expenses/EquitracImport.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('expenses', {
    url: '/expenses',
    template: "<div ui-view class='scrollable-container flex-1 overflow-hidden'></div>",
    controller: ['$state', '$scope', function ($state, $scope) {
      redirectToList();
      $scope.$on('$stateChangeSuccess', redirectToList);
      function redirectToList() {
        if ($state.current.name === 'expenses') {
          $state.go('expenses.list');
        }
      }
    }]
  }).state('expenses.unassigned', {
    url: '/unassigned',
    ...vuetify(UnassignedTable)
  }).state('expenses.unassigned.assign', {
    url: "/assign/{expenseId}",
    views: {
      'edit': {
        ...vuetify(QBOexpense)
      }
    }
  }).state('expenses.import', {
    url: '/import',
    template: require('./views/import.html'),
    controller: 'ImportCtrl'
  }).state('expenses.equitrac-import', {
    url: '/equitrac-import',
    ...vuetify(EquitracImport)
  }).state('expenses.list', {
    url: '/list?expenseId',
    params: {
      matterId: null,
      matterName: null,
      clientId: null,
      clientName: null,
      // Deep-link: open a specific expense on load (mirrors Fixed Fees chargeId pattern)
      expenseId: {
        value: null,
        squash: true
      }
    },
    ...vuetify(ExpenseLists)
  }).state('expenses.expense-import', {
    url: '/expense-import',
    ...vuetify(ExpenseImport)
  }).state('expenses.list.edit', {
    url: "/edit/{expenseId}",
    views: {
      edit: {
        ...vuetify(ExpenseEdit)
      }
    }
  }).state('expenses.list.standard', {
    url: "/standard",
    params: {
      expense: null
    },
    views: {
      'edit': {
        template: require('../accounting/views/expense.standard.html'),
        controller: 'ExpenseStandardCtrl'
      }
    }
  }).state('expenses.list.new', {
    url: "/new",
    params: {
      header: true,
      method: '',
      methodOverride: null
    },
    views: {
      edit: {
        ...vuetify(ExpenseEdit)
      }
    }
  });
}]);